export const CreditCardUtilitiesServiceModule = angular
    .module('app.services.payment.creditCardUtilities', [])
    .service('creditCardUtilities', () => {
        function newCard() {
            return {
                cardNumber: '',
                expMonth: '',
                expYear: ''
            };
        }

        function getCardType(cardNumber) {
            var cardTypeName = '';

            if (/^(34)|^(37)/.test(cardNumber)) {
                cardTypeName = 'American Express';
            } else if (/^4/.test(cardNumber)) {
                cardTypeName = 'Visa';
            } else if (/^5[1-5]/.test(cardNumber)) {
                cardTypeName = 'MasterCard';

            // eslint-disable-next-line max-len
            } else if (/^(6011)|^(622(1(2[6-9]|[3-9][0-9])|[2-8][0-9]{2}|9([01][0-9]|2[0-5])))|^(64[4-9])|^65/.test(cardNumber)) {
                cardTypeName = 'Discover';
            } else if (/^(36|38|30[0-5])/.test(cardNumber)) {
                cardTypeName = 'Diners Club';
            } else if (/^35/.test(cardNumber)) {
                cardTypeName = 'JCB';
            }

            return cardTypeName;
        }

        function getLastFour(cardNumber) {
            return cardNumber.slice(-4);
        }

        function getMaskedCardNumber(cardNumber) {
            return `xxxx xxxx xxxx ${cardNumber.length === 4 ? cardNumber : getLastFour(cardNumber)}`;
        }

        function parseExpiration(value) {
            var month;
            var prefix;
            var year;
            var _ref;

            value = value || '';

            value = value.replace(/\s/g, '');
            _ref = value.split('/', 2);
            month = _ref[0];
            year = _ref[1];

            if ((year != null ? year.length : undefined) === 2 && /^\d+$/.test(year)) {
                prefix = (new Date()).getFullYear();
                prefix = prefix.toString().slice(0, 2);
                year = prefix + year;
            }

            month = parseInt(month);
            year = parseInt(year);

            return {
                month: month,
                year: year
            };
        }

        function getCssClass(cardType) {
            switch (angular.isString(cardType) ? cardType.toUpperCase() : cardType) {
                case 'AMEX':
                case 'AMERICAN EXPRESS':
                    return 'credit-card-img--amex';
                case 'VISA':
                    return 'credit-card-img--visa';
                case 'MC':
                case 'MASTERCARD':
                    return 'credit-card-img--mastercard';
                case 'DISC':
                case 'DISCOVER':
                    return 'credit-card-img--discover';
                case 'DINERS CLUB':
                    return 'credit-card-img--dinersclub';
                case 'JCB':
                    return 'credit-card-img--jcb';
                case 'APPLE_PAY':
                    return 'credit-card-img--applepay';
                default:
                    return 'credit-card-img--unknown';
            }
        }

        return {
            newCard,
            getCardType,
            getLastFour,
            getMaskedCardNumber,
            parseExpiration,
            getCssClass
        };
    })
    .name;



// WEBPACK FOOTER //
// ./src/app/services/utilities/creditCardUtilities.service.js